import { createSlice } from '@reduxjs/toolkit';
import { saveVideoLink, fetchVideos } from '../thunks/videos';

const initialState = {
  videos: [],
  video: {},
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
};

export const videosSlice = createSlice({
  name: 'videos',
  initialState,
  reducers: {
    resetVideos: (state) => {
      state.videos = [];
    },
  },
  extraReducers: {
    [saveVideoLink.pending]: (state) => {
      state.saving = true;
    },
    [saveVideoLink.fulfilled]: (state, action) => {
      state.saving = false;
      state.videos = [action.payload, ...state.videos];
      state.video = action.payload;
    },
    [saveVideoLink.rejected]: (state) => {
      state.saving = false;
    },
    [fetchVideos.pending]: (state) => {
      state.fetching = true;
    },
    [fetchVideos.fulfilled]: (state, action) => {
      state.fetching = false;
      state.videos = action.payload;
    },
    [fetchVideos.rejected]: (state) => {
      state.fetching = false;
      state.isOpen = true;
    },
  },
});

export const { resetVideos } = videosSlice.actions;
